import { Layout, Text, Tag } from '@loadsmart/loadsmart-ui'

import { isEmpty } from 'core/utils/array'

import type { QuoteAccessorial } from '../domain/QuoteAccessorial'

export type QuoteAccessorialsProps = {
  accessorials?: Array<QuoteAccessorial>
}

function QuoteAccessorialsTags({ accessorials }: QuoteAccessorialsProps) {
  if (isEmpty(accessorials)) {
    return (
      <Tag size="small" variant="default">
        No charges requested
      </Tag>
    )
  }

  return (
    <>
      {accessorials!.map(accessorial => (
        <Tag key={accessorial.code} size="small" variant="warning">
          {accessorial.name}
        </Tag>
      ))}
    </>
  )
}

export function QuoteAccessorials({ accessorials }: QuoteAccessorialsProps) {
  return (
    <Layout.Stack space="xs">
      <Text variant="heading-sm-bold">Accessorial charges</Text>
      <Layout.Group space="xs">
        <QuoteAccessorialsTags accessorials={accessorials} />
      </Layout.Group>
    </Layout.Stack>
  )
}
